import { useEffect, useState } from 'react'

/* ==================== 🔔 新增：实时时钟组件 ==================== */
export function Clock() {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  // HH:MM:SS 24h 格式，可按需改 toLocaleTimeString 选项
  return (
    <div className="realtime-clock">
      {now.toLocaleTimeString([], { hour12: false })}
    </div>
  );
}